module.exports = __WEBPACK_EXTERNAL_MODULE_22__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Vue","commonjs2":"vue","commonjs":"vue","amd":"vue"}
// module id = 22
// module chunks = 0 1